import React, { Component } from "react";
import ReactTable, {} from "react-table";
import 'react-table/react-table.css';
import { Col } from "react-bootstrap";
import { FormInputs } from "components/FormInputs/FormInputs.jsx";
import ReactDataToCSV from 'components/ThemeComponents/reactDataToCSV';
import {SortableContainer, SortableElement} from 'react-sortable-hoc';
import arrayMove from 'array-move';
import _ from "lodash";


const Sortableitem = SortableElement(({items, realIndex }) => <div className="rt-tr-group" data-index={realIndex}>{items}</div>)
const Sortablediv = SortableContainer(({items}) => <div className="rt-body">{items}</div>)
const Emptytable = () => <div className="rt-body">
        <div className="rt-tr-group">
            <div className="rt-tr -odd" >
                &nbsp;
            </div>
        </div>
        <div className="rt-tr-group">
            <div className="rt-tr -even" >
                &nbsp;
            </div>
        </div>
        <div className="rt-tr-group">
            <div className="rt-tr -odd" >
                &nbsp;
            </div>
        </div>
        <div className="rt-tr-group">
            <div className="rt-tr -even" >
                &nbsp;
            </div>
        </div>
        <div className="rt-tr-group">
            <div className="rt-tr -odd" >
                &nbsp;
            </div>
        </div>
    </div>



const ShowCols = (props) => {
	return props.props.noCols ?
	<div className="clearfix pull-left" style={{width : '100%'}}>
		{props.children}
	</div>
	:
	<Col md={12} className="mt-md">
		{props.children}
	</Col>
}

const ShowRow = (props) => {
	return props.props.noCols ?
	<div className="row">
		{props.children}
	</div>
	:
	<React.Fragment>
		{props.children}
	</React.Fragment>
}

class MoreButtonsPagination extends Component {
	constructor(props) {
		super(props);
		this.state = {
			sorted: '',
			filtered: '',
			pageSize: this.props.pageSize || 10,
			total: 0,
			page: 0,
			data: [],
			pages: 0,
			showAll: false,
            length:false
		};

	}
	dataCall = (page = this.state.page, filtered = this.state.filtered, sorted = this.state.sorted, pageSize = this.state.pageSize) => {
		var data = {
			filter: filtered,
			pageSize: this.state.showAll ? this.state.total : pageSize,
			sort: sorted,
			page: this.state.showAll ? 0 : page
		};
		this.props.getDataCall(data).then(response => {
			const pagination = response && response.data ? response.data.pagination : null;
			const rows = pagination && Array.isArray(pagination.data) ? pagination.data : [];
			this.setState({
				data: rows,
				pages: (pagination && pagination.last_page) || 0,
				page: (pagination && pagination.current_page) || 0,
				total: (pagination && pagination.total) || 0,
			}, () => {
				this.setState({
					length: rows.length
				}, () => {
					if (this.props.parentCallback) {
						this.props.parentCallback(this.state.length);
					}
				});
			});
		}).catch(() => {
			this.setState({
				data: [],
				pages: 0,
				page: 0,
				total: 0,
				length: 0,
			}, () => {
				if (this.props.parentCallback) {
					this.props.parentCallback(0);
				}
			});
		});
	}
    onSortEnd = ({oldIndex, newIndex}) => {
		console.log("data", this.state.data);
		console.log("oldIndex: ", oldIndex, "newIndex: ", newIndex);
		if (oldIndex !== newIndex) {
			this.setState(({data}) => ({
			  data: arrayMove(data, oldIndex, newIndex),
			}), async () => {
				let newData = _.cloneDeep(this.state.data)
	
				await (()=>{
					for(let i = 0; i < newData.length; i++){
						newData[i].sort_order = i+1;
					}
				})()
	
				this.setState({
					data: newData
				}, ()=>{
					if (this.props.updateSort && this.props.is_dragable) 
					this.props.updateSort(this.state.data)
				})
			});
		}
    };
	// ✅ This prevents dropping between 'Agency' rows
	onSortOver = ({ newIndex, oldIndex }) => {
		if (this.props.orderMoreButtons) {
			const { data } = this.state;
			const draggedItem = data[oldIndex];
			const targetItem = data[newIndex];
	
			if (!draggedItem || draggedItem.model_type !== "App\\Order") return;
	
			// ❌ Prevent moving into Agency section
			if (targetItem && targetItem.model_type === "App\\Agency") {
				console.log("❌ Cannot move into Agency section!");
				
				// Immediately revert any movement visually
				this.setState((prev) => ({
					data: arrayMove(prev.data, newIndex, oldIndex),
				}));
			}
		}
	};
	shouldCancelStart = (event) => {
		if (this.props.orderMoreButtons) {
			// Find the closest .rt-tr-group (not tr)
			const rowDiv = event.target.closest(".rt-tr-group");
			console.log("rowDiv", rowDiv);
			
			if (!rowDiv) return false;
			
			// react-table assigns data-index to each tr via SortableElement
			const indexAttr = rowDiv.getAttribute("data-index");
			console.log("indexAttr", indexAttr);
			if (indexAttr === null) return false;

			const index = parseInt(indexAttr, 10);
			const row = this.state.data[index]; // get row data

			// Debugging
			console.log("Row being checked for drag:", row);

			// ✅ Prevent drag for non-agency rows
			if (row && row.model_type === "App\\Agency") {
				console.log("❌ Drag prevented for non-agency item:", row);
				return true; // cancel drag
			}

			console.log("✅ Drag allowed for agency item:", row);
			return false; // allow drag
		}
	};

	paginationStateData = () => {
		return {...this.state}
	}
	filterSearchHandle = (e) => {
		this.setState({
			'filtered': e.target.value
		});
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.showAll !== this.state.showAll) {
			this.dataCall();
		}
		if (this.state.filtered !== prevState.filtered) {
			this.dataCall();
		}
	}

	render() {
		const { showAll, data, pages, filtered, pageSize, page } = this.state;
		const { showAllToggle, columns, loadingOrder, filterView, upperContent, lowerContent, filterPlaceHolder, downloadData, minRows, downloadFileName, style, showTotal } = this.props;
		return (
			<React.Fragment>
				<ShowCols props={this.props}>
					{
						showTotal &&
                        <p>Your query resulted in a total of {this.state.total}.</p>
					}
					{
						upperContent &&
						upperContent
					}
					<ShowRow props={this.props}>
						{
							this.props.addNewBtn &&
							<Col md={8} sm={8} xs={12} >
								{this.props.addNewBtn}
							</Col>
						}
						{
							filterView &&
							<Col className='pull-right' md={4} sm={6} xs={12} >
								<FormInputs
									ncols={["col-md-12"]}
									onChange={this.filterSearchHandle}
									proprieties={[
										{
											type: "text",
											bsClass: "form-control",
											placeholder: `Search ${filterPlaceHolder ? filterPlaceHolder : ''}`,
											onChange: this.filterSearchHandle,
											name: "filter"
										}
									]}
								/>
							</Col>
						}

						{
							this.props.toggleBtns &&
							<Col md={12} className="mb-md">
								{this.props.toggleBtns}
							</Col>
						}
					</ShowRow>

					{
						lowerContent &&
						lowerContent
					}

					{
						showAllToggle &&
						<React.Fragment>
							<Col md={1} className='pull-right text-right pl-xs'>
								<label className="container-check mb-none" style={{ marginTop: "10px", paddingLeft: "28px" }}> Show All <input type="checkbox" name="is_default" className="checkbox" onChange={() => {
									this.setState({ showAll: !showAll })
								}} /><span className="checkmark"></span></label>
							</Col>
						</React.Fragment>
					}
					{
						downloadData &&
						<React.Fragment>
							<Col md={2} className="mt-sm downloadCsv text-right pull-right">
								<ReactDataToCSV
									className="downloadbtn"
									fileName={downloadFileName}
									currentRecordsRef={this.reactTable}
									columnsData={columns[0].columns}
								/>
							</Col>
						</React.Fragment>
					}
					<ShowCols props={this.props}>
						<ReactTable
							minRows={minRows ? minRows : data.length}
							showPagination={showAll ? false : true}
							ref={(r) => this.reactTable = r}
							trProps={this.props.getRowProps}
							noDataText={this.props.noDataText || "No records found"}
							data={data}
							pages={pages}
							columns={columns}
							filtered={filtered}
							pageSizeOptions={this.props.pageSizeOptions}
							defaultPageSize={pageSize}
							pageSize={pageSize}
							loading={loadingOrder}
							defaultSorted={this.props.defaultSorted || []}
							onPageSizeChange={(pageSize) => {
								this.setState({
									pageSize: pageSize
								})
							}}
							style = {style}
							className="-striped listing"
							loadingText={'Loading...'}
							pageData={this.dataCall}
							manual
							onFetchData={(state, instance) => {
								var sort = state.sorted.length === 0 ? '' : state.sorted[0].id + ',desc:' + state.sorted[0].desc;
								state.pageData(state.page + 1, state.filtered, sort, state.pageSize);
							}}
                            TbodyComponent = {
								(instance) => data.length 
								? 
									<Sortablediv 
										distance={1} 
										helperClass={`trmoving`} 
										axis={'y'} 
										transitionDuration={400}  
										onSortEnd={this.onSortEnd} 
										shouldCancelStart={this.shouldCancelStart}  
										onSortOver={this.onSortOver}  
										items={instance.children} /> 
								: 
									<Emptytable />
							}
                            TrGroupComponent = {
								(instance) => 
								{
									const realIndex = instance.myProps ? instance.myProps.index : 0;
									return (

										<Sortableitem 
      										key={`item-${realIndex}`}
											index={realIndex}
											realIndex={realIndex}  // 👈 pass it manually
											items={instance.children} />
									)
								}
							}
							getTrProps={(state, rowInfo, columns, instance) => {
								let data = {};
								if (instance.props.trProps) {
									if (rowInfo !== undefined) {
										const rowData = rowInfo.original;
										data = instance.props.trProps(rowData);
									}
								}
								return {
									style: data
								};
							}}
							getTrGroupProps={(state, rowInfo, columns, instance) => {
								// return rowInfo && {myProps: rowInfo}
								if (!rowInfo) return {};
								const isOrder = rowInfo.original.model_type === "App\\Order";
								return {
									myProps: rowInfo,
									draggable: isOrder
								};
							}}
						/>
					</ShowCols>
				</ShowCols>
			</React.Fragment>
		);
	}
}
export default MoreButtonsPagination;